// extracted by mini-css-extract-plugin
export default {"isAction":"cardIsAction-module__isAction--yx_ns","isGrid":"cardIsAction-module__isGrid--XUmKP"};